import React from 'react';
import ConditionGroup from './ConditionGroup';
import ConditionLeaf from './ConditionLeaf';
import {
  IConditionGroup,
  IConditionLeaf,
  IConditionNode,
  IRulesetSchemaField,
  isConditionGroup,
} from '../../../types/ruleset-types';

interface ConditionTreeProps {
  node: IConditionNode;
  schema: { fields: IRulesetSchemaField[] };
  depth: number;
  onChange: (node: IConditionNode) => void;
  onRemove: () => void;
  dataPoolId: string;
  isRoot?: boolean;
  disabled?: boolean;
  insideNot?: boolean;
}

const ConditionTree: React.FC<ConditionTreeProps> = ({
  node,
  schema,
  depth,
  onChange,
  onRemove,
  dataPoolId,
  isRoot = false,
  disabled = false,
  insideNot = false,
}) => {
  if (isConditionGroup(node)) {
    return (
      <ConditionGroup
        group={node}
        schema={schema}
        depth={depth}
        onChange={(updated) => onChange(updated as IConditionNode)}
        onRemove={onRemove}
        dataPoolId={dataPoolId}
        isRoot={isRoot}
        disabled={disabled}
        insideNot={insideNot}
      />
    );
  }

  return (
    <ConditionLeaf
      condition={node as IConditionLeaf}
      schema={schema}
      onChange={(updated) => onChange(updated as IConditionNode)}
      onRemove={onRemove}
      dataPoolId={dataPoolId}
      disabled={disabled}
    />
  );
};

export default ConditionTree;
